document.addEventListener('DOMContentLoaded', function() {
  var sections = document.querySelectorAll('[data-ha-vp-section]');

  sections.forEach(function(sectionEl) {
    var mediaTarget = sectionEl.querySelector('[data-main-media]');
    var detailEls   = sectionEl.querySelectorAll('.ha-vp__accordion details');

    function swapImageFromSummary(summaryEl) {
      if (!mediaTarget || !summaryEl) return;
      var html = summaryEl.getAttribute('data-image-html');
      if (!html) return;
      mediaTarget.innerHTML = html;
    }

    detailEls.forEach(function(detailsEl) {
      var summaryEl = detailsEl.querySelector('summary');
      if (!summaryEl) return;

      summaryEl.addEventListener('click', function() {
        // let <details> toggle first, then normalize state
        requestAnimationFrame(function() {

          // close all siblings except the one just interacted with
          detailEls.forEach(function(otherEl) {
            if (otherEl !== detailsEl) {
              otherEl.removeAttribute('open');
              var otherSummary = otherEl.querySelector('summary');
              if (otherSummary) {
                otherSummary.setAttribute('aria-expanded', 'false');
              }
            }
          });

          // sync aria-expanded and update image for the active item
          if (detailsEl.hasAttribute('open')) {
            summaryEl.setAttribute('aria-expanded', 'true');
            swapImageFromSummary(summaryEl);
          } else {
            summaryEl.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });

    // On load: show image for the first open item, else first item.
    var defaultOpen = sectionEl.querySelector('.ha-vp__accordion details[open] summary');
    if (defaultOpen) {
      swapImageFromSummary(defaultOpen);
    } else {
      var firstSummary = sectionEl.querySelector('.ha-vp__accordion details summary');
      if (firstSummary) {
        swapImageFromSummary(firstSummary);
      }
    }
  });
});